import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { Material } from '../_types/material';
import { MaterialsService } from '../_services/materials.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-materials-detail',
    templateUrl: './materials-detail.component.html',
    styleUrls: ['./materials-detail.component.scss'],
    standalone: false
})
export class MaterialsDetailComponent {
  public materialFormGroup!: RxFormGroup;

  public material: Material = new Material();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private materialsService: MaterialsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {

    this.materialFormGroup = this.formBuilder.formGroup<Material>(this.material) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de material");
    this.topbarService.addBreadcrumb("Materiales", "/materials");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadMaterial(id);
    }

    this.allowWrite = this.loginService.hasPermission("MATERIALS.WRITE");
    this.allowDelete = this.loginService.hasPermission("MATERIALS.DELETE");
  }

  async loadMaterial(id: string) {
    this.material = await firstValueFrom(this.materialsService.get(id));
    this.materialFormGroup.patchValue(this.material);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.materialFormGroup);
    if (valid) {
      this.material = Object.assign(this.material, this.materialFormGroup.value);

      //guardamos material
      let material = await firstValueFrom(this.materialsService.save(this.material));

      this.messageService.add({ closable: true, severity: 'success', summary: "Material guardado correctamente." });

      
      this.router.navigate(['materials']);
    

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el material "+this.material.name+"?",
      header: "Eliminar material",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.materialsService.delete(this.material.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Material eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['materials']);
  }

}
